import { defineStore } from 'pinia';
import { reactive } from 'vue';
import { usePiniaRefStore } from '../composables/usePiniaRefStore';

export interface CompanionPairingTokenRecord {
  pairingToken: string;
  pairingTokenExpiresAt: string;
}

export const useCompanionTokenStore = defineStore('companionToken', () => {
  const pairingTokens = reactive(new Map<string, CompanionPairingTokenRecord>());

  const getToken = (sessionId: string) => {
    return pairingTokens.get(sessionId) ?? null;
  };

  const setToken = (sessionId: string, token: CompanionPairingTokenRecord, ttl = 300000) => {
    pairingTokens.set(sessionId, token);
    if (ttl > 0) setTimeout(() => pairingTokens.delete(sessionId), ttl);
  };

  const invalidateToken = (sessionId: string) => {
    pairingTokens.delete(sessionId);
  };

  return { pairingTokens, getToken, setToken, invalidateToken };
});

export const useCompanionTokens = () => usePiniaRefStore(useCompanionTokenStore());
